import { render, staticRenderFns } from "./recontent.vue?vue&type=template&id=0dc92763&scoped=true&"
import script from "./recontent.vue?vue&type=script&lang=js&"
export * from "./recontent.vue?vue&type=script&lang=js&"
import style1 from "./recontent.vue?vue&type=style&index=1&id=0dc92763&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc92763",
  null
  
)

export default component.exports